export default "__VITE_ASSET__DwAsNBES__"